// Language badge palette and grouping helpers.

const LANGUAGE_GROUPS = {
  english: { family: 'germanic', bg: 'rgba(37,99,235,0.14)', border: 'rgba(37,99,235,0.34)', text: '#2563eb' },
  swedish: { family: 'germanic', bg: 'rgba(14,165,233,0.14)', border: 'rgba(14,165,233,0.34)', text: '#0ea5e9' },
  german: { family: 'germanic', bg: 'rgba(59,130,246,0.14)', border: 'rgba(59,130,246,0.34)', text: '#3b82f6' },
  dutch: { family: 'germanic', bg: 'rgba(96,165,250,0.14)', border: 'rgba(96,165,250,0.34)', text: '#60a5fa' },
  danish: { family: 'germanic', bg: 'rgba(56,189,248,0.14)', border: 'rgba(56,189,248,0.34)', text: '#38bdf8' },
  norwegian: { family: 'germanic', bg: 'rgba(2,132,199,0.14)', border: 'rgba(2,132,199,0.34)', text: '#0284c7' },

  yiddish: { family: 'jewish-germanic', bg: 'rgba(124,58,237,0.14)', border: 'rgba(124,58,237,0.34)', text: '#7c3aed' },
  hebrew: { family: 'semitic', bg: 'rgba(217,119,6,0.14)', border: 'rgba(217,119,6,0.34)', text: '#d97706' },
  arabic: { family: 'semitic', bg: 'rgba(234,88,12,0.14)', border: 'rgba(234,88,12,0.34)', text: '#ea580c' },

  polish: { family: 'slavic', bg: 'rgba(220,38,38,0.12)', border: 'rgba(220,38,38,0.3)', text: '#dc2626' },
  russian: { family: 'slavic', bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.3)', text: '#ef4444' },
  ukrainian: { family: 'slavic', bg: 'rgba(244,63,94,0.12)', border: 'rgba(244,63,94,0.3)', text: '#f43f5e' },
  czech: { family: 'slavic', bg: 'rgba(225,29,72,0.12)', border: 'rgba(225,29,72,0.3)', text: '#e11d48' },
  slovak: { family: 'slavic', bg: 'rgba(251,113,133,0.14)', border: 'rgba(251,113,133,0.34)', text: '#fb7185' },

  hungarian: { family: 'uralic', bg: 'rgba(5,150,105,0.14)', border: 'rgba(5,150,105,0.34)', text: '#059669' },
  finnish: { family: 'uralic', bg: 'rgba(16,185,129,0.14)', border: 'rgba(16,185,129,0.34)', text: '#10b981' },
  estonian: { family: 'uralic', bg: 'rgba(20,184,166,0.14)', border: 'rgba(20,184,166,0.34)', text: '#14b8a6' },

  french: { family: 'romance', bg: 'rgba(249,115,22,0.14)', border: 'rgba(249,115,22,0.34)', text: '#f97316' },
  italian: { family: 'romance', bg: 'rgba(251,146,60,0.14)', border: 'rgba(251,146,60,0.34)', text: '#fb923c' },
  spanish: { family: 'romance', bg: 'rgba(245,158,11,0.14)', border: 'rgba(245,158,11,0.34)', text: '#f59e0b' },
  portuguese: { family: 'romance', bg: 'rgba(234,179,8,0.14)', border: 'rgba(234,179,8,0.34)', text: '#eab308' },
  romanian: { family: 'romance', bg: 'rgba(202,138,4,0.14)', border: 'rgba(202,138,4,0.34)', text: '#ca8a04' },
};

const LANGUAGE_FAMILY_FALLBACKS = {
  germanic: { bg: 'rgba(59,130,246,0.14)', border: 'rgba(59,130,246,0.34)', text: '#3b82f6' },
  'jewish-germanic': { bg: 'rgba(124,58,237,0.14)', border: 'rgba(124,58,237,0.34)', text: '#7c3aed' },
  slavic: { bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.3)', text: '#ef4444' },
  uralic: { bg: 'rgba(5,150,105,0.14)', border: 'rgba(5,150,105,0.34)', text: '#059669' },
  romance: { bg: 'rgba(249,115,22,0.14)', border: 'rgba(249,115,22,0.34)', text: '#f97316' },
  semitic: { bg: 'rgba(217,119,6,0.14)', border: 'rgba(217,119,6,0.34)', text: '#d97706' },
  unknown: { bg: 'rgba(100,116,139,0.12)', border: 'rgba(100,116,139,0.28)', text: '#64748b' },
};

const FAMILY_MATCHERS = [
  [/yiddish/i, 'jewish-germanic'],
  [/(english|swedish|german|dutch|danish|norwegian|icelandic|afrikaans)/i, 'germanic'],
  [/(polish|russian|ukrainian|czech|slovak|belarusian|serbian|croatian|bosnian|slovene|bulgarian)/i, 'slavic'],
  [/(hungarian|finnish|estonian)/i, 'uralic'],
  [/(french|italian|spanish|portuguese|romanian|catalan)/i, 'romance'],
  [/(hebrew|arabic|aramaic)/i, 'semitic'],
];

const LANGUAGE_CODES = {
  english: 'EN',
  swedish: 'SV',
  german: 'DE',
  dutch: 'NL',
  danish: 'DA',
  norwegian: 'NO',
  yiddish: 'YI',
  hebrew: 'HE',
  arabic: 'AR',
  polish: 'PL',
  russian: 'RU',
  ukrainian: 'UK',
  czech: 'CS',
  slovak: 'SK',
  hungarian: 'HU',
  finnish: 'FI',
  estonian: 'ET',
  french: 'FR',
  italian: 'IT',
  spanish: 'ES',
  portuguese: 'PT',
  romanian: 'RO',
  lithuanian: 'LT',
  latvian: 'LV',
  chinese: 'ZH',
  japanese: 'JA',
  turkish: 'TR',
  greek: 'EL',
  serbian: 'SR',
  croatian: 'HR',
  bosnian: 'BS',
  bulgarian: 'BG',
};

// Language code → country flag emoji (uses regional indicator pairs)
const LANG_FLAGS = {
  en: '🇬🇧', sv: '🇸🇪', de: '🇩🇪', nl: '🇳🇱', da: '🇩🇰', no: '🇳🇴', nb: '🇳🇴',
  yi: '🏳️', he: '🇮🇱', ar: '🇸🇦',
  pl: '🇵🇱', ru: '🇷🇺', uk: '🇺🇦', cs: '🇨🇿', sk: '🇸🇰',
  hu: '🇭🇺', fi: '🇫🇮', et: '🇪🇪',
  fr: '🇫🇷', it: '🇮🇹', es: '🇪🇸', pt: '🇵🇹', ro: '🇷🇴',
  lt: '🇱🇹', lv: '🇱🇻', zh: '🇨🇳', ja: '🇯🇵', tr: '🇹🇷', el: '🇬🇷',
  sr: '🇷🇸', hr: '🇭🇷', bs: '🇧🇦', bg: '🇧🇬', is: '🇮🇸', sq: '🇦🇱',
};

// Reverse lookup: 2-letter code → full name (e.g. 'sv' → 'swedish')
const CODE_TO_NAME = {};
Object.entries(LANGUAGE_CODES).forEach(([name, code]) => {
  CODE_TO_NAME[code.toLowerCase()] = name;
});
// 3-letter code aliases
CODE_TO_NAME['yid'] = 'yiddish';
CODE_TO_NAME['heb'] = 'hebrew';
CODE_TO_NAME['eng'] = 'english';
CODE_TO_NAME['deu'] = 'german';
CODE_TO_NAME['pol'] = 'polish';
CODE_TO_NAME['rus'] = 'russian';
CODE_TO_NAME['fra'] = 'french';
CODE_TO_NAME['spa'] = 'spanish';

export function getLanguageMeta(language) {
  const raw = String(language || '').trim();
  if (!raw) return { label: 'Language unknown', family: 'unknown', ...LANGUAGE_FAMILY_FALLBACKS.unknown };

  const key = raw.toLowerCase();
  // Resolve 2-letter codes to full names (sv → swedish)
  const resolved = CODE_TO_NAME[key] || key;
  const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
  if (LANGUAGE_GROUPS[resolved]) {
    return { label: capitalize(resolved), ...LANGUAGE_GROUPS[resolved] };
  }

  const family = FAMILY_MATCHERS.find(([re]) => re.test(resolved))?.[1] || 'unknown';
  return { label: capitalize(resolved), family, ...LANGUAGE_FAMILY_FALLBACKS[family] };
}

// Reverse lookup: full name → 2-letter code
const NAME_TO_CODE = {};
Object.entries(LANGUAGE_CODES).forEach(([name, code]) => {
  NAME_TO_CODE[name] = code.toLowerCase();
});

export function normalizeLanguageKey(language) {
  const raw = String(language || '').trim().toLowerCase();
  if (!raw) return '';
  // If it's already a short code (2-3 chars), return as-is
  if (raw.length <= 3) return raw;
  // Convert full name to code
  return NAME_TO_CODE[raw] || raw;
}

export function isRightToLeftLanguage(language) {
  const key = normalizeLanguageKey(language);
  return ['hebrew', 'arabic', 'yiddish', 'he', 'ar', 'yi'].includes(key);
}

export function getLanguageFontFamily(language, fallback = 'inherit') {
  const key = normalizeLanguageKey(language);
  if (key === 'hebrew') {
    return `'Noto Sans Hebrew', 'Arial Hebrew', 'Segoe UI', sans-serif`;
  }
  if (key === 'arabic') {
    return `'Noto Naskh Arabic', 'Tahoma', sans-serif`;
  }
  return fallback;
}

export function getLanguageCode(language) {
  const key = normalizeLanguageKey(language);
  if (!key) return '--';
  return LANGUAGE_CODES[key] || key.slice(0, 2).toUpperCase();
}

export function getLanguageFlag(language) {
  const code = normalizeLanguageKey(language);
  // Try direct code lookup first
  if (LANG_FLAGS[code]) return LANG_FLAGS[code];
  // Try converting full name to code
  const shortCode = NAME_TO_CODE[code];
  if (shortCode && LANG_FLAGS[shortCode]) return LANG_FLAGS[shortCode];
  return '';
}

export function getLanguageName(code) {
  const key = String(code || '').trim().toLowerCase();
  const resolved = CODE_TO_NAME[key] || key;
  return resolved.charAt(0).toUpperCase() + resolved.slice(1);
}
